import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import ConfigurePage                                          from '@/pages/configure-page.vue';
import StartPage                                              from '@/pages/start-page.vue';
import PavingSurface                                              from '@/pages/paving-surface.vue';
import Curb                                              from '@/pages/curb.vue';
import ScarpElement                                              from '@/pages/scarp-element.vue';
import Grout                                              from '@/pages/grout.vue';
import Impregnation                                              from '@/pages/impregnation.vue';
import Addons                                              from '@/pages/addons.vue';
import Summary                                              from '@/pages/summary.vue';
import YourInfo                                              from '@/pages/your-info.vue';
import SalesSalon                                              from '@/pages/sales-salon.vue';
import Done                                              from '@/pages/done.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path     : '/start',
    name     : 'Start',
    component: StartPage,
    meta: {
      next: 'configure',
      prev: ''
    }
  },
  {
    path     : '/configure',
    name     : 'Configure',
    component: ConfigurePage,
    meta: {
      next: 'paving-surface',
      prev: 'start'
    }
  },
  {
    path     : '/paving-surface',
    name     : 'Paving surface',
    component: PavingSurface,
    meta: {
      next: 'curb',
      prev: 'configure'
    }
  },
  {
    path     : '/curb',
    name     : 'Curb',
    component: Curb,
    meta: {
      next: 'scarp-element',
      prev: 'paving-surface'
    }
  },
  {
    path     : '/scarp-element',
    name     : 'Scarp element',
    component: ScarpElement,
    meta: {
      next: 'grout',
      prev: 'curb'
    }
  },
  {
    path     : '/grout',
    name     : 'Grout',
    component: Grout,
    meta: {
      next: 'impregnation',
      prev: 'scarp-element'
    }
  },
  {
    path     : '/impregnation',
    name     : 'Impregnation',
    component: Impregnation,
    meta: {
      next: 'addons',
      prev: 'grout'
    }
  },
  {
    path     : '/addons',
    name     : 'Addons',
    component: Addons,
    meta: {
      next: 'summary',
      prev: 'impregnation'
    }
  },
  {
    path     : '/summary',
    name     : 'Summary',
    component: Summary,
    meta: {
      next: 'your-info',
      prev: 'addons'
    }
  },
  {
    path     : '/your-info',
    name     : 'Your info',
    component: YourInfo,
    meta: {
      next: 'sales-salon',
      prev: 'summary'
    }
  },
  {
    path     : '/sales-salon',
    name     : 'Sales salon',
    component: SalesSalon,
    meta: {
      next: '',
      prev: 'your-info'
    }
  },
  {
    path     : '/done',
    name     : 'Done',
    component: Done,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/start'
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
